export default __webpack_public_path__ + "static/media/roller_coaster@3x.5c299fc2.png";